import React, { useState, useEffect } from "react";
import SectionKelola from "../../../components/CrudUserSetup/SectionKelola";
import ConfirmDialog from "../../../components/Feedback/ConfirmDialog";
import AlertDialog from "../../../components/Feedback/AlertDialog";
import {
  getAllPositions,
  createPosition,
  updatePosition,
  deletePosition,
} from "../../../services/positionService";

import {
  getAllMemberStatus,
  createMemberStatus,
  updateMemberStatus,
  deleteMemberStatus,
} from "../../../services/memberStatusService";

import {
  getAllRoles,
  createRole,
  updateRole,
  deleteRole,
} from "../../../services/roleService";

const AdminSetup = () => {
  const [jabatan, setJabatan] = useState([]);
  const [statusAdmin, setStatusAdmin] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // ✅ Fetch dari API
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Jabatan hanya ADMIN
        const positions = await getAllPositions();
        const adminOnly = positions.filter(
          (item) => item.status?.toUpperCase() === "ADMIN"
        );
        setJabatan(adminOnly);

        // Status hanya ADMIN
        const status = await getAllMemberStatus();
        const adminStatus = status.filter(
          (item) => item.status?.toUpperCase() === "ADMIN"
        );
        setStatusAdmin(adminStatus);

        // Roles hanya ADMIN
        const allRoles = await getAllRoles();
        const adminRoles = allRoles.filter(
          (item) => item.status?.toUpperCase() === "ADMIN"
        );
        setRoles(adminRoles);
      } catch (err) {
        console.error("Gagal memuat data:", err);
      }
    };

    fetchData();
  }, []);

  // ✅ CRUD JABATAN
  const handleAddJabatan = async (name) => {
    try {
      const res = await createPosition({ name, status: "ADMIN" });
      const newItem = res.data?.data || res.data;
      setJabatan((prev) => [newItem, ...prev]);
      setAlertMessage("Jabatan admin berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah jabatan admin:", err);
    }
  };

  const handleEditJabatan = async (item) => {
    try {
      const res = await updatePosition(item.id, {
        name: item.name,
        status: "ADMIN",
      });
      const updated = res.data?.data || res.data;
      setJabatan((prev) =>
        prev.map((j) => (j.id === updated.id ? updated : j))
      );
    } catch (err) {
      console.error("Gagal mengedit jabatan admin:", err);
    }
  };

  // const handleDeleteJabatan = async (item) => {
  //   try {
  //     if (!item?.id) throw new Error("ID jabatan tidak ditemukan");
  //     console.log("Menghapus jabatan dengan ID:", item.id);
  //     await deletePosition(item.id);
  //     setJabatan((prev) => prev.filter((j) => j.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus jabatan admin:",
  //       err.response?.data || err.message
  //     );
  //   }
  // };

  // ✅ CRUD STATUS ADMIN (pakai API)
  const handleAddStatus = async (name) => {
    try {
      const res = await createMemberStatus({ name, status: "ADMIN" });
      const newItem = res.data?.data || res.data;
      setStatusAdmin((prev) => [newItem, ...prev]);
      setAlertMessage("Status admin berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah status admin:", err);
    }
  };

  const handleEditStatus = async (item) => {
    try {
      const res = await updateMemberStatus(item.id, {
        name: item.name,
        status: "ADMIN",
      });
      console.log("RESP UPDATE STATUS", res);

      const updated = res.data?.data || res.data;
      setStatusAdmin((prev) =>
        prev.map((s) => (s.id === updated.id ? updated : s))
      );
    } catch (err) {
      console.error("Gagal mengedit status admin:", err.response || err);
    }
  };

  // const handleDeleteStatus = async (item) => {
  //   try {
  //     if (!item?.id) throw new Error("ID status tidak ditemukan");
  //     console.log("Menghapus status dengan ID:", item.id);
  //     await deleteMemberStatus(item.id);
  //     setStatusAdmin((prev) => prev.filter((s) => s.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus status admin:",
  //       err.response?.data || err.message
  //     );
  //   }
  // };

  // ✅ CRUD ROLE ADMIN (pakai API)

  const handleAddRole = async (name) => {
    try {
      const res = await createRole({ name, status: "ADMIN" });
      const newItem = res.data?.data || res.data;
      setRoles((prev) => [newItem, ...prev]);
      setAlertMessage("Role admin berhasil ditambahkan!");
      setIsAlertOpen(true);
    } catch (err) {
      console.error("Gagal menambah role admin:", err);
      console.log("DETAIL ERROR:", err.response?.data || err.message);
    }
  };

  const handleEditRole = async (item) => {
    try {
      const res = await updateRole(item.id, {
        name: item.name,
        status: "ADMIN",
      });
      const updated = res.data?.data || res.data;
      setRoles((prev) => prev.map((r) => (r.id === updated.id ? updated : r)));
    } catch (err) {
      console.error("Gagal mengedit role admin:", err);
    }
  };

  // const handleDeleteRole = async (item) => {
  //   try {
  //     if (!item?.id) throw new Error("ID role tidak ditemukan");
  //     console.log("Menghapus role dengan ID:", item.id);
  //     await deleteRole(item.id);
  //     setRoles((prev) => prev.filter((r) => r.id !== item.id));
  //   } catch (err) {
  //     console.error(
  //       "Gagal menghapus role admin:",
  //       err.response?.data || err.message
  //     );
  //   }
  // };
  const handleConfirmDelete = async () => {
    if (!selectedDeleteItem) return;

    try {
      if (deleteType === "jabatan") {
        await deletePosition(selectedDeleteItem.id);
        setJabatan((prev) =>
          prev.filter((j) => j.id !== selectedDeleteItem.id)
        );
      } else if (deleteType === "status") {
        await deleteMemberStatus(selectedDeleteItem.id);
        setStatusAdmin((prev) =>
          prev.filter((s) => s.id !== selectedDeleteItem.id)
        );
      } else if (deleteType === "role") {
        await deleteRole(selectedDeleteItem.id);
        setRoles((prev) => prev.filter((r) => r.id !== selectedDeleteItem.id));
      }
    } catch (err) {
      console.error("Gagal menghapus:", err.response?.data || err.message);
    } finally {
      setIsConfirmOpen(false);
      setSelectedDeleteItem(null);
      setDeleteType("");
    }
  };

  return (
    <div className="pt-10 pb-10 pl-64 pr-6">
      <h1 className="mb-6 text-2xl font-bold text-green-800">
        Manajemen Admin
      </h1>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {/* CRUD Jabatan via API */}
        <SectionKelola
          title="Jabatan Admin"
          data={jabatan}
          onAdd={handleAddJabatan}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("jabatan");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditJabatan}
        />

        {/* CRUD Status Admin via API */}
        <SectionKelola
          title="Status Admin"
          data={statusAdmin}
          onAdd={handleAddStatus}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("status");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditStatus}
        />

        {/* CRUD Role Admin via localStorage */}
        <SectionKelola
          title="Role Admin"
          data={roles}
          onAdd={handleAddRole}
          onDelete={(item) => {
            setSelectedDeleteItem(item);
            setDeleteType("role");
            setIsConfirmOpen(true);
          }}
          onEdit={handleEditRole}
        />
      </div>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Hapus Data"
        message="Apakah Anda yakin ingin menghapus data ini?"
      />
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => setIsAlertOpen(false)}
          title="Berhasil"
          message={alertMessage}
        />
      )}
    </div>
  );
};

export default AdminSetup;
